export enum ProviderType {
  LOCAL = 'LOCAL',
  GOOGLE = 'GOOGLE',
  MICROSOFT = 'MICROSOFT',
  GITHUB = 'GITHUB',
  /** Generic OIDC provider (deployment-configured issuer). */
  OIDC = 'OIDC',
  WEB3_STELLAR = 'WEB3_STELLAR',
}

export enum AccessType {
  READ = 'READ',
  WRITE = 'WRITE',
  ADMIN = 'ADMIN',
}

export enum OrgRoles {
  USER           = 0x00,
  BILLING        = 0x01,
  WORKSPACES     = 0x02,
  ADMINISTRATORS = 0xfe,
  OWNER          = 0xff,
}

export interface UserSummary {
  id: string;
  name: string;
  lastName: string;
  email: string;
  orgRole?: number | null;
}
